import { render, staticRenderFns } from "./ContatoLocal.vue?vue&type=template&id=38eebe7b&"
import script from "./ContatoLocal.vue?vue&type=script&lang=ts&"
export * from "./ContatoLocal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports